module.exports = __webpack_public_path__ + "img/wanshiruyi_01_579d1e69a.png";